var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckClear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14498",
    "data-name": "Grupo 14498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14497",
    "data-name": "Grupo 14497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14166",
    "data-name": "Caminho 14166",
    d: "M14.5,0A14.5,14.5,0,1,0,29,14.5,14.516,14.516,0,0,0,14.5,0Zm0,26.754A12.254,12.254,0,1,1,26.754,14.5,12.268,12.268,0,0,1,14.5,26.754Z",
    fill: "#54e046",
    stroke: "#54e046",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14500",
    "data-name": "Grupo 14500",
    transform: "translate(7.481 9.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14499",
    "data-name": "Grupo 14499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14167",
    "data-name": "Caminho 14167",
    d: "M145.751,162.115a1.124,1.124,0,0,0-1.586.076l-6.851,7.544L134,166.371a1.123,1.123,0,0,0-1.6,1.575l4.143,4.212a1.122,1.122,0,0,0,.8.336h.021a1.124,1.124,0,0,0,.81-.368l7.65-8.424A1.124,1.124,0,0,0,145.751,162.115Z",
    transform: "translate(-132.079 -161.824)",
    fill: "#54e046",
    stroke: "#54e046",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckClear);
export default __webpack_public_path__ + "static/media/check-clear.d372d10eba286d8c7b653c32adacae80.svg";
export { ForwardRef as ReactComponent };